export default "/images/become-host-4.jpeg?461d25bbf004f479a1a890116b609fd3";